import type { FC } from 'react';
import React from 'react';

import { KolQuote } from '@public-ui/react-v19';
import { SampleBlock } from '../SampleBlock';
import { SampleDescription } from '../SampleDescription';

export const QuoteBasic: FC = () => (
	<>
		<SampleDescription>
			<p>KolQuote renders a quote with optional citation. This sample shows a quote in the variant &quot;inline&quot; with a link for citation.</p>
		</SampleDescription>

		<SampleBlock id="basic">
			<KolQuote _href="https://datatracker.ietf.org/doc/html/rfc1149" _quote="Avian carriers can provide high delay." _variant="inline"></KolQuote>
		</SampleBlock>
	</>
);
